<div class=prod-tabs>
  <div class="container">
    <nav>
      @for (item2 of mergedObject1; track item2; let i = $index) {
        <div class="prod-tabs__tab-nav nav nav-tab" id="nav-tab" role="tablist">
          <button class="nav-link" [ngClass]="toggleArray[i] == true ? 'active' : ''" data-toggle="tab"
            [attr.data-bs-target]="'#nav-content-' + i" type="button" role="tab" [attr.aria-controls]="'nav-content-' + i"
            [attr.aria-selected]="i === 0 ? 'true' : 'false'" (click)="toggleNav(i)">
            @if (item2.h2content) {
              <span class="nav-tab-content">
                {{ item2.h2content }}
                <div class="prod-tabs__arrow">
                  <img role="presentation" alt="Next screen" src="../../../assets/images/arrow-right.svg">
                </div>
              </span>
            }
          </button>
          <div class="prod-tabs__tab tab-pane fade d-lg-none d-xl-none" [ngClass]="toggleArray[i] == true ? 'show active' : ''" role="tabpanel">
            <div [attr.aria-labelledby]="'nav-tab-' + i">
              <div class="prod-tabs__body">
                <h3 [innerHTML]="item2.content"></h3>
                @if (item2.mediaPdf) {
                  <p class="centered-text">
                    <img [src]="getImage(item2.mediaPdf)" />
                  </p>
                }
                <p class="afluria-sub3" [innerHTML]="item2.pdfLinkContent"></p>
              </div>
            </div>
          </div>
        </div>
      }
    </nav>
    <div class="prod-tabs__tab-content" id="nav-tabContent">
      @for (item2 of mergedObject1; track item2; let i = $index) {
        <div class="prod-tabs__tab tab-pane fade d-none d-lg-block" [ngClass]="toggleArray[i] == true ? 'show active' : ''" role="tabpanel">
          <div [attr.aria-labelledby]="'nav-tab-' + i">
            <div class="prod-tabs__body">
              <h3 [innerHTML]="item2.content"></h3>
              @if (item2.mediaPdf) {
                <p class="centered-text">
                  <img [src]="getImage(item2.mediaPdf)" />
                </p>
              }
              <p [innerHTML]="item2.pdfLinkContent"></p>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>